import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './index.module.scss';
import { BlockTitle } from 'src/shared';
import { TASK_EDITOR_ICON_MAPPER } from 'src/models/bids/BidTask/mappers';

const AnswerTopBar: FC = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <BlockTitle title={t('BiddingTool.answer')} icon={TASK_EDITOR_ICON_MAPPER['answer']} />
    </div>
  );
};

export default AnswerTopBar;
